import * as actions from 'src/app/recruiting/candidates/live-nurses-new/store/live-nurses.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';
import { JobItem } from 'src/app/recruiting/candidates/live-nurses-new/components/jobs/models/dto/job-item';

export interface JobOptionsState {
    jobOptions: JobItem[];
    loading: LoadingTypes;
}

const initialState: JobOptionsState = {
    jobOptions: [],
    loading: LoadingTypes.INIT
};

export function liveNursesJobOptionsReducer(state: JobOptionsState, action: Action) {
    return createReducer(
        initialState,
        on(actions.loadJobOptions, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADING
        })),

        on(actions.loadJobOptionsSuccess, (state, action) => {
            const otherJobOptions = state.jobOptions.filter((n) => !action.submittalIds.includes(n.submittalId));
            // const otherJobOptions = state.jobOptions.filter(n => !action.jobOptions.map(an=> an.id).includes(n.id));
            return {
                ...state,
                jobOptions: [...otherJobOptions, ...action.jobOptions],
                loading: LoadingTypes.LOADED
            };
        }),

        on(actions.loadJobOptionsFail, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADED
        }))
    )(state, action);
}

export function reducer(state: JobOptionsState | undefined, action: Action) {
    return liveNursesJobOptionsReducer(state, action);
}
